import React from "react";
import OpenSourceImg from "../../assets/opensource.png";

const videodbRepos = [
  {
    name: "Director",
    description: "Video AI platform with multi-agent orchestration",
    url: "https://github.com/video-db/Director",
  },
  {
    name: "videodb-node",
    description: "Node.js SDK for VideoDB",
    url: "https://github.com/video-db/videodb-node",
  },
  {
    name: "n8n-nodes-videodb",
    description: "n8n integration nodes (2k+ downloads)",
    url: "https://github.com/video-db/n8n-nodes-videodb",
  },
  {
    name: "videodb-chat",
    description: "Chat interface for VideoDB Director",
    url: "https://github.com/video-db/videodb-chat",
  },
  {
    name: "videodb-python",
    description: "Python SDK for VideoDB",
    url: "https://github.com/video-db/videodb-python",
  },
];

export default function OpenSource() {
  return (
    <div className="fade-in py-8 px-2 md:px-4 max-w-[90%] mx-auto">
      {/* VideoDB Section */}
      <div className="mb-12">
        <h3 className="text-lg font-medium mb-3">VideoDB</h3>
        <p className="text-gray-500 mb-4">
          Core maintainer and contributor to VideoDB's open-source ecosystem,
          including the{" "}
          <span className="text-neutral-200">
            Node.js SDK, Director AI platform, n8n integration
          </span>
          , and more.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {videodbRepos.map((repo) => (
            <a
              key={repo.name}
              href={repo.url}
              target="_blank"
              rel="noreferrer"
              className="group flex flex-col gap-1 p-4 rounded-lg border border-neutral-800 hover:border-neutral-600 transition-all duration-300 hover:bg-neutral-900/50"
            >
              <div className="flex items-center gap-2">
                <i className="fa-brands fa-github text-neutral-400 group-hover:text-white transition-all duration-300"></i>
                <span className="text-neutral-200 group-hover:text-white transition-all duration-300 font-medium">
                  {repo.name}
                </span>
              </div>
              <p className="text-gray-500 text-sm">{repo.description}</p>
            </a>
          ))}
        </div>
      </div>

      {/* Layer5 Section */}
      <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-8">
        <img
          alt="Open source contributions in Layer5"
          className="block mx-auto mb-4 outline outline-1 rounded-lg outline-neutral-700 w-full md:w-[50%] max-w-[360px] md:max-w-[440px]"
          src={OpenSourceImg}
        />
        <div className="flex flex-col gap-2">
          <h3 className="text-lg font-medium">Layer5</h3>
          <p className="text-gray-500 my-2 mx-auto text-justify">
            My contributions to Layer5 were focused on improving the performance
            of their site on the Accessibility and SEO front. My contributions
            improved their{" "}
            <span className="text-neutral-200">
              Lighthouse Accessibility score from{" "}
              <span className="text-white">83</span> to an impressive{" "}
              <span className="text-white">91</span>
            </span>
            .
          </p>
          <div className="flex flex-col w-full">
            <a
              target="_blank"
              className="text-neutral-400 hover:text-white text-sm transition-all duration-300 py-1 flex items-center gap-2 hover:gap-3"
              href="https://github.com/layer5io/layer5/issues/4265"
              rel="noreferrer"
            >
              <i className="fa-brands fa-github"></i>
              Improved score from 83 to 86
            </a>
            <a
              target="_blank"
              className="text-neutral-400 hover:text-white text-sm transition-all duration-300 py-2 flex items-center gap-2 hover:gap-3"
              href="https://github.com/layer5io/layer5/issues/5415"
              rel="noreferrer"
            >
              <i className="fa-brands fa-github"></i>
              Improved score from 86 to 91
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
